(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.trans = this.dataset.trans;
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerWrapper = document.querySelector('.header-wrapper');

      /* Announcement Bar Height */
    this.announcementBar = document.querySelector('.announcement-bar-section');
    if (this.announcementBar) {
      this.setAnnounceHeight();
    } else {
      document.documentElement.style.setProperty('--announce-height', '0px');
    }

      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();

      window.matchMedia('(max-width: 992px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.onScroll();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

     /* Announcement Height Function */
    setAnnounceHeight() {
      document.documentElement.style.setProperty('--announce-height', `${this.announcementBar.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if(this.trans != 'none') this.classList.remove('trans_header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if(this.trans != 'none') this.classList.remove('trans_header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        if(this.trans != 'none') this.classList.add('trans_header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
   if(document.getElementsByTagName("sticky-header").length == 0){
    document.documentElement.style.setProperty('--header-height', '0px');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["panda-service-hub"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('panda-service-hub')) {
  class PandaServiceHub extends HTMLElement {
    static overlayLayers = new Map();
    static joinBorders = new Map();
    static joinProperties = ['border-image-source', 'border-image-slice', 'border-image-width', 'border-image-outset', 'border-image-repeat', 'box-shadow'];
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.menu = ''; this.category = ''; this.ready = false; this.links = []; this.warnings = [];
      this.raisedHeaders = new Set();
      this.joinedHeaders = new Set();
      this.menus = Array.from(this.querySelectorAll('[data-menu]'));
      this.categories = Array.from(this.querySelectorAll('[data-category]'));
      this.modules = Array.from(this.querySelectorAll('[data-module]'));
      this.warrantyModule = this.querySelector('[data-warranty-module]');
      this.supportLabels = this.querySelector('.psh-support-labels');
      this.supportMode = this.supportLabels?.dataset.enabled === 'true';
      this.supportMenu = this.supportLabels?.dataset.menuKey || '';
      this.supportChoices = new Map();
      this.supportTopic = 'video';
      this.faqViewKey = '';
      this.supportModelChoices = new Map();
      this.supportModelPicker = this.querySelector('.psh-support-model-picker');
      this.faqIntro = this.querySelector('[data-faq-intro]');
      this.faqIntroTemplates = Array.from(this.querySelectorAll('[data-manual-faq-intro-template]'));
      this.supportModelSelect = this.querySelector('[data-support-model-select]');
      this.supportModelHint = this.querySelector('[data-support-model-hint]');
      this.supportLayout = this.querySelector('.psh-support-layout');
      this.supportTopicNav = this.querySelector('.psh-support-topics');
      this.supportTopics = Array.from(this.supportTopicNav.querySelectorAll('[data-support-topic]'));
      this.appLabels = this.querySelector('.psh-app-labels');
      this.appDownloadMode = this.appLabels?.dataset.enabled === 'true';
      this.appMenu = this.appLabels?.dataset.menuKey || '';
      this.appEmpty = this.querySelector('.psh-app-empty');
      this.nav = this.querySelector('.psh-nav');
      this.navSlot = this.querySelector('.psh-nav-slot');
      this.content = this.querySelector('.psh-content');
      this.normalHeight = 76;
      this.menuGuide = this.querySelector('.psh-menu-guide');
      this.categoryGuide = this.querySelector('.psh-category-guide');
      this.categoryStage = this.querySelector('.psh-category-stage');
      this.categoryNav = this.querySelector('.psh-categories');
      this.serviceBody = this.querySelector('.psh-service-body');
      this.menuAnimations = [];
      const options = { signal: this.abort.signal };
      this.videoRotationObserver = new ResizeObserver(entries => entries.forEach(entry => this.updateVideoRotation(entry.target)));
      this.querySelectorAll('[data-responsive-video]').forEach(player => this.videoRotationObserver.observe(player));
      ['loadedmetadata', 'resize'].forEach(type => this.addEventListener(type, event => {
        if (event.target instanceof HTMLVideoElement) {
          const player = event.target.closest('[data-responsive-video]');
          if (player) this.updateVideoRotation(player);
        }
      }, { ...options, capture: true }));
      this.validateKeys();
      this.bindSections();
      this.addEventListener('click', event => {
        const rotate = event.target.closest('[data-video-rotate]');
        if (rotate && this.contains(rotate)) {
          const player = rotate.closest('[data-responsive-video]');
          this.updateVideoRotation(player);
          if (!rotate.hidden) {
            player.classList.toggle('is-rotated');
            this.updateVideoRotation(player);
          }
          return;
        }
        const topic = event.target.closest('button[data-support-topic]');
        if (topic && this.contains(topic)) {
          this.supportChoices.set(this.category, topic.dataset.supportTopic);
          this.supportTopic = topic.dataset.supportTopic;
          this.render();
          this.dispatchEvent(new CustomEvent('panda:support:topic', { bubbles: true, detail: { category: this.category, topic: this.supportTopic } }));
          return;
        }
        const button = event.target.closest('button[data-menu],button[data-category]');
        if (!button || !this.contains(button) || button.disabled) return;
        if (button.hasAttribute('data-menu')) this.select(button.dataset.menu === this.menu ? '' : button.dataset.menu);
        else this.select(this.menu, button.dataset.category);
        if (this.menu && this.navSlot.getBoundingClientRect().top < this.headerBottom()) {
          requestAnimationFrame(() => window.scrollTo({ top: Math.max(0, this.navSlot.getBoundingClientRect().top + window.scrollY - this.headerBottom() + 1), behavior: 'instant' }));
        }
      }, options);
      this.addEventListener('toggle', event => {
        const item = event.target;
        if (!(item instanceof HTMLDetailsElement) || !item.matches('[data-support-faq-item]') || !item.open || !this.ready || this.menu !== this.supportMenu || this.supportTopic !== 'faq') return;
        const owner = item.closest('[data-support-module][data-support-topic="faq"]');
        if (!owner || owner.hidden) return;
        this.querySelectorAll('[data-support-module][data-support-topic="faq"]:not([hidden]) [data-support-faq-item][open]').forEach(other => { if (other !== item) other.open = false; });
      }, { ...options, capture: true });
      this.supportModelSelect.addEventListener('change', () => {
        this.supportModelChoices.set(this.category, this.supportModelSelect.value);
        this.render();
        this.dispatchEvent(new CustomEvent('panda:support:model', { bubbles: true, detail: { category: this.category, model: this.supportModelSelect.selectedOptions[0]?.textContent || '', value: this.supportModelSelect.value } }));
      }, options);
      this.supportTopicNav.addEventListener('keydown', event => {
        if (!['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        const index = this.supportTopics.indexOf(event.target);
        if (index < 0) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.supportTopics.length - 1 : (index + (['ArrowDown', 'ArrowRight'].includes(event.key) ? 1 : -1) + this.supportTopics.length) % this.supportTopics.length;
        this.supportTopics[next].focus(); this.supportTopics[next].click();
      }, options);
      this.addEventListener('submit', event => {
        if (!event.target.matches('.psh-contact')) return;
        const block = event.target.closest('[data-module]');
        const state = { section: this.dataset.sectionId, block: block.dataset.blockId, form: event.target.id, at: Date.now() };
        try { sessionStorage.setItem('panda-service-contact', JSON.stringify(state)); } catch {}
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const block = this.querySelector('[data-block-id="' + CSS.escape(event.detail.blockId) + '"]');
        if (!block) return;
        if (block.hasAttribute('data-menu')) this.select(block.dataset.menu);
        else if (block.hasAttribute('data-category')) this.select(block.dataset.parent, block.dataset.category);
        else {
          if (block.hasAttribute('data-support-module')) {
            this.supportChoices.set(block.dataset.categoryKey, block.dataset.supportTopic);
            if (block.dataset.supportTopic !== 'faq') this.supportModelChoices.set(block.dataset.categoryKey, this.supportModelKey(block));
          }
          this.selectContent(block);
        }
      }, options);
      document.addEventListener('shopify:section:load', () => { this.releaseSections(); this.bindSections(); this.render(); }, options);
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(this)) this.cleanup();
        else { this.releaseSections(); this.bindSections(); this.render(); }
      }, options);
      document.addEventListener('shopify:section:reorder', () => { this.releaseSections(); this.bindSections(); this.render(); }, options);
      const schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.updateSticky(); if (performance.now() < this.headerTrackUntil) schedule(); }); };
      window.addEventListener('scroll', schedule, { ...options, passive: true });
      window.addEventListener('resize', () => {
        this.stopMenuAnimations();
        this.supportTopicNav.setAttribute('aria-orientation', 'vertical');
        this.renderResponsiveVideos();
        schedule();
      }, options);
      window.addEventListener('pageshow', schedule, options);
      this.resizeObserver = new ResizeObserver(schedule);
      this.resizeObserver.observe(this);
      this.resizeObserver.observe(this.nav);
      this.getHeaders().forEach(header => this.resizeObserver.observe(header));
      this.headerObserver = new MutationObserver(() => { this.headerTrackUntil = performance.now() + 450; schedule(); });
      this.getHeaders().forEach(header => this.headerObserver.observe(header, { attributes: true, subtree: true, attributeFilter: ['class', 'style', 'open', 'aria-expanded'] }));
      this.links.forEach(link => this.resizeObserver.observe(link.target));
      this.select('');
      this.restoreForm();
      this.render();
      schedule();
    }
    warn(text) {
      if (!this.warnings.includes(text)) this.warnings.push(text);
      const box = this.querySelector('.psh-warning');
      if (box) { box.textContent = this.warnings.join(' / '); box.hidden = false; }
    }
    validateKeys() {
      const seenMenus = new Set(), seenCategories = new Set();
      this.menus.forEach(button => {
        const key = button.dataset.menu;
        if (!key || seenMenus.has(key)) { button.disabled = true; this.warn('一级菜单键为空或重复: ' + key); }
        else seenMenus.add(key);
      });
      this.categories.forEach(button => {
        const key = button.dataset.parent + '/' + button.dataset.category;
        if (!button.dataset.category || !seenMenus.has(button.dataset.parent) || seenCategories.has(key)) { button.disabled = true; this.warn('二级分类键无效或重复: ' + key); }
        else seenCategories.add(key);
      });
      this.modules.forEach(block => {
        if ((this.supportMode && block.dataset.parent === this.supportMenu && !block.hasAttribute('data-support-module')) || (!this.supportMode && block.hasAttribute('data-support-module'))) return;
        if ((this.appDownloadMode && block.dataset.parent === this.appMenu && !block.hasAttribute('data-app-model')) || (!this.appDownloadMode && block.hasAttribute('data-app-model'))) return;
        if (!seenMenus.has(block.dataset.parent) || (block.dataset.categoryKey && !seenCategories.has(block.dataset.parent + '/' + block.dataset.categoryKey))) this.warn('内容块的菜单/分类键不存在: ' + block.dataset.blockId);
      });
    }
    select(menu, category) {
      if (!this.menus.some(button => !button.disabled && button.dataset.menu === menu)) menu = '';
      const available = this.categories.filter(button => !button.disabled && button.dataset.parent === menu);
      const nextCategory = available.some(button => button.dataset.category === category) ? category : '';
      const changingStage = Boolean(menu) !== Boolean(this.menu);
      const choosingCategory = menu === this.menu && !this.category && Boolean(nextCategory);
      const motion = !matchMedia('(prefers-reduced-motion: reduce)').matches;
      const before = changingStage && motion ? this.menus.map(button => this.captureMenuButton(button)) : [];
      const categoryBefore = choosingCategory && motion ? available.map(button => this.captureMenuButton(button)) : [];
      const previousHeight = this.navSlot.getBoundingClientRect().height;
      const categoryHeight = this.categoryStage.getBoundingClientRect().height;
      const previousMenu = this.menu;
      this.stopMenuAnimations();
      if (menu) this.classList.add('has-interacted');
      this.menu = menu;
      this.category = nextCategory;
      this.ready = Boolean(menu) && (available.length === 0 || Boolean(nextCategory));
      this.supportTopic = this.supportChoices.get(this.category) || 'video';
      this.render();
      if (changingStage && motion) this.animateMenuStage(before, previousHeight);
      else if (choosingCategory && motion) this.animateCategoryStage(available, categoryBefore, categoryHeight);
      else if (motion && menu && previousMenu !== menu && !this.ready) this.menuAnimations.push(this.categoryStage.animate([
        { opacity: 0, transform: 'translateY(24px)' }, { opacity: 1, transform: 'translateY(0)' }
      ], { duration: 360, easing: 'ease-out' }));
    }
    selectContent(block) {
      const available = this.categories.filter(button => !button.disabled && button.dataset.parent === block.dataset.parent);
      const target = available.find(button => button.dataset.category === block.dataset.categoryKey) || available[0];
      this.select(block.dataset.parent, target?.dataset.category || '');
    }
    captureMenuButton(button) {
      const style = getComputedStyle(button);
      const label = button.querySelector('.psh-category-label, .psh-category-text, .psh-menu-label');
      return { rect: button.getBoundingClientRect(), fontSize: parseFloat(getComputedStyle(label || button).fontSize), background: style.backgroundColor, radius: style.borderRadius, shadow: style.boxShadow };
    }
    animateCategoryStage(buttons, before, previousHeight) {
      const timing = { duration: 560, easing: 'cubic-bezier(.22,.8,.25,1)' };
      buttons.forEach((button, index) => {
        const from = before[index]?.rect;
        const to = button.getBoundingClientRect();
        if (!from?.width || !to.width || !to.height) return;
        this.menuAnimations.push(button.animate([
          { transformOrigin: '0 0', transform: 'translate(' + (from.left - to.left) + 'px,' + (from.top - to.top) + 'px) scale(' + from.width / to.width + ',' + from.height / to.height + ')' },
          { transformOrigin: '0 0', transform: 'translate(0,0) scale(1,1)' }
        ], timing));
        const label = button.querySelector('.psh-category-label, .psh-category-text');
        if (label) {
          const scale = before[index].fontSize / parseFloat(getComputedStyle(label).fontSize);
          this.menuAnimations.push(label.animate([
            { transform: 'scale(' + scale * to.width / from.width + ',' + scale * to.height / from.height + ')' },
            { transform: 'scale(1,1)' }
          ], timing));
        }
      });
      const nextHeight = this.categoryStage.getBoundingClientRect().height;
      this.menuAnimations.push(this.categoryStage.animate([{ height: previousHeight + 'px' }, { height: nextHeight + 'px' }], timing));
      this.menuAnimations.push(this.serviceBody.animate([
        { opacity: 0, transform: 'translateY(18px)' }, { opacity: 1, transform: 'translateY(0)' }
      ], { duration: 320, delay: 280, fill: 'backwards', easing: 'ease-out' }));
    }
    stopMenuAnimations() {
      (this.menuAnimations || []).forEach(animation => animation.cancel());
      this.menuAnimations = [];
    }
    animateMenuStage(before, previousHeight) {
      const duration = 560;
      const timing = { duration, easing: 'cubic-bezier(.22,.8,.25,1)' };
      this.menus.forEach((button, index) => {
        const from = before[index]?.rect;
        const appearance = before[index];
        const to = button.getBoundingClientRect();
        if (!from?.width || !to.width || !to.height) return;
        const style = getComputedStyle(button);
        this.menuAnimations.push(button.animate([
          { transformOrigin: '0 0', transform: 'translate(' + (from.left - to.left) + 'px,' + (from.top - to.top) + 'px) scale(' + from.width / to.width + ',' + from.height / to.height + ')', backgroundColor: appearance.background, borderRadius: appearance.radius, boxShadow: appearance.shadow },
          { transformOrigin: '0 0', transform: 'translate(0,0) scale(1,1)', backgroundColor: style.backgroundColor, borderRadius: style.borderRadius, boxShadow: style.boxShadow }
        ], timing));
        const label = button.querySelector('.psh-menu-label');
        const textScale = appearance.fontSize / parseFloat(style.fontSize);
        if (label) this.menuAnimations.push(label.animate([
          { transform: 'scale(' + textScale * to.width / from.width + ',' + textScale * to.height / from.height + ')' },
          { transform: 'scale(1,1)' }
        ], timing));
      });
      const nextHeight = this.navSlot.getBoundingClientRect().height;
      if (this.menu) this.menuAnimations.push(this.navSlot.animate([{ height: previousHeight + 'px' }, { height: nextHeight + 'px' }], timing));
      if (this.menu) this.menuAnimations.push(this.content.animate([
        { opacity: 0, transform: 'translateY(18px)' },
        { opacity: 1, transform: 'translateY(0)' }
      ], { duration: 320, delay: 260, fill: 'backwards', easing: 'ease-out' }));
    }
    supportModelKey(block) {
      const name = (block.dataset.supportModel || '').trim();
      return name ? 'model:' + name : 'legacy:';
    }
    renderSupportModels(active) {
      const gated = active;
      this.supportModelPicker.hidden = !gated;
      if (!gated) return;
      const models = new Map();
      this.modules.forEach(block => {
        if (!block.hasAttribute('data-support-module') || !['video', 'manual'].includes(block.dataset.supportTopic)) return;
        if (block.dataset.parent !== this.supportMenu || (block.dataset.categoryKey && block.dataset.categoryKey !== this.category)) return;
        const key = this.supportModelKey(block);
        if (!models.has(key)) models.set(key, (block.dataset.supportModel || '').trim() || this.supportModelSelect.dataset.legacy);
      });
      const options = [new Option(this.supportModelSelect.dataset.prompt, '')];
      models.forEach((label, key) => options.push(new Option(label, key)));
      const signature = JSON.stringify(Array.from(models));
      if (this.supportModelSelect.dataset.options !== signature) {
        this.supportModelSelect.replaceChildren(...options);
        this.supportModelSelect.dataset.options = signature;
      }
      const selected = this.supportModelChoices.get(this.category) || '';
      this.supportModelSelect.value = models.has(selected) ? selected : '';
      if (selected && !models.has(selected)) this.supportModelChoices.delete(this.category);
      this.supportModelSelect.disabled = models.size === 0;
      this.supportModelHint.textContent = models.size ? this.supportModelHint.dataset.hint : this.supportModelHint.dataset.empty;
      this.supportModelHint.hidden = Boolean(this.supportModelSelect.value);
    }
    renderFaqIntro(active) {
      const selected = this.supportModelChoices.get(this.category) || '';
      const template = active && selected ? this.faqIntroTemplates.find(item => item.dataset.parent === this.supportMenu && (!item.dataset.categoryKey || item.dataset.categoryKey === this.category) && this.supportModelKey(item) === selected) : null;
      this.faqIntro.hidden = !template;
      if (!template) return;
      if (this.faqIntro.dataset.sourceManual !== template.dataset.sourceManual) {
        this.faqIntro.replaceChildren(template.content.cloneNode(true));
        this.faqIntro.dataset.sourceManual = template.dataset.sourceManual;
      }
    }
    matches(block) {
      if (!this.ready) return false;
      if (block.hasAttribute('data-default-faq-placeholder')) {
        const selected = this.supportModelChoices.get(this.category) || '';
        if (selected && this.modules.some(item => item.hasAttribute('data-manual-faq-source') && (!item.dataset.categoryKey || item.dataset.categoryKey === this.category) && this.supportModelKey(item) === selected)) return false;
      }
      if (this.warrantyModule && block.hasAttribute('data-target') && block.dataset.parent === this.warrantyModule.dataset.parent && block.dataset.categoryKey === 'warranty') return false;
      const match = Boolean(this.menu) && block.dataset.parent === this.menu && (!block.dataset.categoryKey || block.dataset.categoryKey === this.category);
      if (this.appDownloadMode && block.dataset.parent === this.appMenu && !block.hasAttribute('data-app-model')) return false;
      if (!this.appDownloadMode && block.hasAttribute('data-app-model')) return false;
      if (this.supportMode && block.dataset.parent === this.supportMenu && !block.hasAttribute('data-support-module')) return false;
      if (!this.supportMode && block.hasAttribute('data-support-module')) return false;
      if (block.hasAttribute('data-support-module') && block.dataset.supportTopic !== this.supportTopic) return false;
      if (block.hasAttribute('data-support-module') && (['video', 'manual'].includes(block.dataset.supportTopic) || block.hasAttribute('data-manual-faq-group'))) {
        const selected = this.supportModelChoices.get(this.category);
        if (!selected || this.supportModelKey(block) !== selected) return false;
      }
      return match;
    }
    render() {
      this.classList.toggle('is-intro', !this.menu);
      const awaitingCategory = Boolean(this.menu) && !this.ready;
      this.classList.toggle('is-category-intro', awaitingCategory);
      this.categoryGuide.setAttribute('aria-hidden', String(!awaitingCategory));
      if (awaitingCategory && this.categoryGuide.textContent.trim()) this.categoryNav.setAttribute('aria-describedby', this.categoryGuide.id);
      else this.categoryNav.removeAttribute('aria-describedby');
      this.serviceBody.hidden = !this.ready;
      this.menuGuide.setAttribute('aria-hidden', String(Boolean(this.menu)));
      if (!this.menu && this.menuGuide.textContent.trim()) this.nav.setAttribute('aria-describedby', this.menuGuide.id);
      else this.nav.removeAttribute('aria-describedby');
      this.menus.forEach(button => button.setAttribute('aria-expanded', String(button.dataset.menu === this.menu && Boolean(this.menu))));
      this.categories.forEach(button => { button.hidden = !this.menu || button.dataset.parent !== this.menu || button.disabled; button.setAttribute('aria-pressed', String(!button.hidden && button.dataset.category === this.category)); });
      this.content.hidden = !this.menu;
      const supportActive = this.supportMode && this.menu === this.supportMenu && this.ready;
      this.categoryNav.classList.toggle('is-product-categories', (this.supportMode && this.menu === this.supportMenu) || (this.appDownloadMode && this.menu === this.appMenu));
      this.supportLayout.classList.toggle('is-active', supportActive);
      this.supportTopicNav.hidden = !supportActive;
      this.supportTopicNav.setAttribute('aria-orientation', 'vertical');
      this.renderSupportModels(supportActive);
      this.renderFaqIntro(supportActive && this.supportTopic === 'faq');
      const faqViewKey = JSON.stringify([this.menu, this.category, this.supportTopic, this.supportModelChoices.get(this.category) || '']);
      if (faqViewKey !== this.faqViewKey) {
        this.querySelectorAll('[data-support-faq-item][open]').forEach(item => { item.open = false; });
        this.faqViewKey = faqViewKey;
      }
      this.supportTopics[0].textContent = this.category === 'smart-glasses' ? this.supportLabels.dataset.userVideo : this.supportLabels.dataset.installation;
      this.supportTopics.forEach(button => button.setAttribute('aria-selected', String(supportActive && button.dataset.supportTopic === this.supportTopic)));
      const stack = this.querySelector('.psh-stack');
      if (supportActive) { stack.setAttribute('role', 'tabpanel'); stack.setAttribute('aria-labelledby', this.id + '-topic-' + this.supportTopic); }
      else { stack.removeAttribute('role'); stack.removeAttribute('aria-labelledby'); }
      const empty = this.querySelector('.psh-support-empty');
      const modelFaqs = this.modules.some(block => block.hasAttribute('data-manual-faq-group') && block.dataset.categoryKey === this.category);
      const sharedFaqs = this.modules.some(block => block.dataset.supportTopic === 'faq' && !block.hasAttribute('data-manual-faq-group') && this.matches(block));
      const awaitingModel = !this.supportModelSelect.value && (['video', 'manual'].includes(this.supportTopic) || (this.supportTopic === 'faq' && modelFaqs && !sharedFaqs));
      empty.hidden = !supportActive || awaitingModel || (this.supportTopic === 'faq' && !this.faqIntro.hidden) || this.modules.some(block => block.hasAttribute('data-support-module') && this.matches(block));
      empty.querySelector('[data-support-empty-title]').textContent = this.supportTopics.find(button => button.dataset.supportTopic === this.supportTopic)?.textContent || '';
      const appActive = this.appDownloadMode && this.menu === this.appMenu && this.ready;
      this.appEmpty.hidden = !appActive || this.modules.some(block => block.hasAttribute('data-app-model') && this.matches(block));
      this.modules.forEach(block => {
        const visible = this.matches(block);
        block.hidden = !visible;
        if (visible) this.renderResponsiveVideos(block);
        block.querySelectorAll('video').forEach(video => { if (!visible) video.pause(); });
        block.querySelectorAll('iframe[data-video-src]').forEach(frame => { if (visible) { if (!frame.hasAttribute('src')) frame.src = frame.dataset.videoSrc; } else frame.removeAttribute('src'); });
      });
      this.links.forEach(link => {
        const visible = !link.suppressed && this.matches(link.block);
        const wasHidden = link.target.hidden;
        link.target.hidden = !visible;
        if (!visible) {
          link.target.querySelectorAll('video').forEach(video => video.pause());
          link.target.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
        }
        if (visible && wasHidden) link.target.dispatchEvent(new CustomEvent('panda:section:shown', { bubbles: true, detail: { serviceHub: this.id } }));
      });
      this.updateSticky();
    }
    renderResponsiveVideos(scope = this) {
      const device = matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop';
      scope.querySelectorAll('[data-responsive-video]').forEach(player => {
        if (player.closest('[data-module]')?.hidden || this.content.hidden) return;
        const template = player.querySelector('template[data-video-template="' + device + '"]');
        const mount = player.querySelector('[data-video-mount]');
        if (!template || !mount) return;
        if (mount.dataset.videoKey !== template.dataset.videoKey) {
          mount.querySelectorAll('video').forEach(video => video.pause());
          mount.querySelectorAll('iframe').forEach(frame => frame.removeAttribute('src'));
          player.classList.remove('is-rotated');
          mount.replaceChildren(template.content.cloneNode(true));
          mount.dataset.videoKey = template.dataset.videoKey;
        }
        player.dataset.videoRatio = template.dataset.videoRatio;
        this.updateVideoRotation(player);
        mount.querySelectorAll('iframe[data-video-src]').forEach(frame => {
          if (!frame.hasAttribute('src')) frame.src = frame.dataset.videoSrc;
        });
      });
    }
    updateVideoRotation(player) {
      const button = player.querySelector('[data-video-rotate]');
      if (!button) return;
      const mount = player.querySelector('[data-video-mount]');
      const video = mount.querySelector('video');
      const ratio = video?.videoWidth && video.videoHeight ? video.videoWidth / video.videoHeight : Number(player.dataset.videoRatio) || 0;
      const playable = Boolean(video || mount.querySelector('iframe'));
      const canRotate = matchMedia('(max-width: 749px)').matches && playable && (ratio === 0 || ratio > 1);
      button.hidden = !canRotate;
      if (!canRotate) player.classList.remove('is-rotated');
      const rotated = player.classList.contains('is-rotated');
      if (rotated) {
        player.style.setProperty('--psh-rotated-ratio', String(1 / (ratio || 16 / 9)));
        player.style.setProperty('--psh-rotated-width', player.clientHeight + 'px');
        player.style.setProperty('--psh-rotated-height', player.clientWidth + 'px');
      } else {
        player.style.removeProperty('--psh-rotated-ratio');
        player.style.removeProperty('--psh-rotated-width');
        player.style.removeProperty('--psh-rotated-height');
      }
      button.setAttribute('aria-pressed', String(rotated));
      button.querySelector('[data-video-rotate-label]').textContent = rotated ? button.dataset.resetLabel : button.dataset.rotateLabel;
    }
    getHeaders() {
      const selector = this.dataset.headerSelector || '.section-header, #shopify-section-header, .shopify-section-group-header-group, sticky-header, header[role="banner"]';
      try { return Array.from(document.querySelectorAll(selector)).filter(element => !this.contains(element)); }
      catch { this.warn('顶部导航 CSS 选择器无效'); return []; }
    }
    headerBottom() {
      let bottom = 0;
      this.getHeaders().forEach(header => {
        const rect = header.getBoundingClientRect();
        const style = getComputedStyle(header);
        if (style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.top <= bottom + 4 && rect.bottom > bottom && rect.bottom < window.innerHeight * .7) bottom = rect.bottom;
      });
      return Math.max(0, bottom + (Number(this.dataset.topOffset) || 0));
    }
    headerRoots() {
      const roots = this.getHeaders().map(header => header.closest('.section-header') || header.closest('.shopify-section-group-header-group') || header);
      const primary = roots.filter(header => header.matches('.section-header'));
      return Array.from(new Set(primary.length ? primary : roots));
    }
    releaseHeader(header) {
      const record = PandaServiceHub.overlayLayers.get(header);
      if (!record) return;
      record.owners.delete(this);
      if (record.owners.size) {
        const layer = String(Math.max(...record.owners.values()));
        if (header.style.getPropertyValue('z-index') !== layer) header.style.setProperty('z-index', layer, 'important');
      } else {
        if (record.originalValue) header.style.setProperty('z-index', record.originalValue, record.originalPriority);
        else header.style.removeProperty('z-index');
        PandaServiceHub.overlayLayers.delete(header);
      }
      this.raisedHeaders.delete(header);
    }
    syncHeaderOverlays(layer) {
      const active = new Set();
      this.headerRoots().forEach(header => {
        const expanded = header.matches('.menu-open') || header.querySelector('details[open], dialog[open], [aria-expanded="true"][aria-controls]');
        if (!expanded) return;
        active.add(header);
        let record = PandaServiceHub.overlayLayers.get(header);
        if (!record) {
          const computed = getComputedStyle(header).zIndex;
          record = { baseLayer: computed === 'auto' ? 0 : Number(computed), originalValue: header.style.getPropertyValue('z-index'), originalPriority: header.style.getPropertyPriority('z-index'), owners: new Map() };
          PandaServiceHub.overlayLayers.set(header, record);
        }
        record.owners.set(this, layer + 1);
        const elevated = String(Math.max(...record.owners.values()));
        if (header.style.getPropertyValue('z-index') !== elevated || header.style.getPropertyPriority('z-index') !== 'important') header.style.setProperty('z-index', elevated, 'important');
        this.raisedHeaders.add(header);
      });
      Array.from(this.raisedHeaders).forEach(header => { if (!active.has(header)) this.releaseHeader(header); });
    }
    paintHeaderJoin(header, record) {
      if (!record.owners.size) {
        record.shadowElement?.remove();
        record.original.forEach(({ property, value, priority }) => {
          if (value) header.style.setProperty(property, value, priority);
          else header.style.removeProperty(property);
        });
        PandaServiceHub.joinBorders.delete(header);
        return;
      }
      const ranges = Array.from(record.owners.values()).sort((a, b) => a[0] - b[0]);
      const merged = [];
      ranges.forEach(range => {
        const previous = merged[merged.length - 1];
        if (previous && range[0] <= previous[1]) previous[1] = Math.max(previous[1], range[1]);
        else merged.push([...range]);
      });
      const color = getComputedStyle(header).borderBottomColor;
      const stops = [color + ' 0%'];
      merged.forEach(([left, right]) => stops.push(color + ' ' + left + '%', 'transparent ' + left + '%', 'transparent ' + right + '%', color + ' ' + right + '%'));
      stops.push(color + ' 100%');
      const values = record.hasBorder ? ['linear-gradient(to right, ' + stops.join(', ') + ')', '1', '0 0 1 0', '0', 'stretch'] : [];
      if (record.shadow !== 'none') {
        values[5] = 'none';
        if (!record.shadowElement) {
          record.shadowElement = document.createElement('span');
          record.shadowElement.className = 'psh-header-shadow';
          record.shadowElement.setAttribute('aria-hidden', 'true');
          record.shadowElement.append(document.createElement('span'));
          header.append(record.shadowElement);
        }
        const shadowStops = ['#000 0%'];
        merged.forEach(([left, right]) => shadowStops.push('#000 ' + left + '%', 'transparent ' + left + '%', 'transparent ' + right + '%', '#000 ' + right + '%'));
        shadowStops.push('#000 100%');
        const mask = 'linear-gradient(to right, ' + shadowStops.join(', ') + ')';
        if (record.mask !== mask) { record.shadowElement.style.maskImage = mask; record.mask = mask; }
        const shadowBox = record.shadowElement.firstElementChild;
        const height = header.getBoundingClientRect().height + 'px';
        if (shadowBox.style.height !== height) shadowBox.style.height = height;
        if (!record.shadowPainted) { shadowBox.style.boxShadow = record.shadow; record.shadowPainted = true; }
      }
      record.applied ||= new Map();
      PandaServiceHub.joinProperties.forEach((property, index) => {
        if (values[index] === undefined) return;
        const applied = record.applied.get(property);
        if (!applied || applied.input !== values[index] || header.style.getPropertyValue(property) !== applied.value || header.style.getPropertyPriority(property) !== 'important') {
          header.style.setProperty(property, values[index], 'important');
          record.applied.set(property, { input: values[index], value: header.style.getPropertyValue(property) });
        }
      });
    }
    releaseHeaderJoin(header) {
      const record = PandaServiceHub.joinBorders.get(header);
      if (record) {
        record.owners.delete(this);
        this.paintHeaderJoin(header, record);
      }
      this.joinedHeaders.delete(header);
    }
    syncHeaderJoin(stuck, top) {
      const active = new Set();
      if (stuck) {
        const island = this.nav.querySelector('.psh-island').getBoundingClientRect();
        this.headerRoots().forEach(root => {
          const header = root.matches('.header-wrapper') ? root : root.querySelector('.header-wrapper') || root;
          const rect = header.getBoundingClientRect();
          const style = getComputedStyle(header);
          const hasBorder = parseFloat(style.borderBottomWidth) > 0 && style.borderBottomStyle === 'solid' && !['Top', 'Left', 'Right'].some(side => parseFloat(style['border' + side + 'Width']) > 0);
          const shadow = PandaServiceHub.joinBorders.get(header)?.shadow || style.boxShadow;
          if (rect.width <= 0 || rect.bottom <= 0 || Math.abs(rect.bottom - top) > 1 || (!hasBorder && (shadow === 'none' || shadow.includes('inset')))) return;
          const left = Math.max(0, (island.left - 16 - rect.left) / rect.width * 100);
          const right = Math.min(100, (island.right + 16 - rect.left) / rect.width * 100);
          if (right <= left) return;
          active.add(header);
          let record = PandaServiceHub.joinBorders.get(header);
          if (!record) {
            record = { original: PandaServiceHub.joinProperties.map(property => ({ property, value: header.style.getPropertyValue(property), priority: header.style.getPropertyPriority(property) })), owners: new Map(), hasBorder, shadow: shadow.includes('inset') ? 'none' : shadow };
            PandaServiceHub.joinBorders.set(header, record);
          }
          record.owners.set(this, [Number(left.toFixed(4)), Number(right.toFixed(4))]);
          this.paintHeaderJoin(header, record);
          this.joinedHeaders.add(header);
        });
      }
      Array.from(this.joinedHeaders).forEach(header => { if (!active.has(header)) this.releaseHeaderJoin(header); });
    }
    updateSticky() {
      if (!this.nav || !this.isConnected) return;
      const configuredLayer = Number(getComputedStyle(this).getPropertyValue('--psh-z')) || 2;
      const headerLayers = this.headerRoots().map(header => {
        const managed = PandaServiceHub.overlayLayers.get(header);
        const value = getComputedStyle(header).zIndex;
        return managed ? managed.baseLayer : value === 'auto' ? 0 : Number(value);
      }).filter(Number.isFinite);
      const effectiveLayer = Math.max(configuredLayer, (headerLayers.length ? Math.max(...headerLayers) : 3) + 1);
      this.style.setProperty('--psh-effective-z', String(effectiveLayer));
      this.syncHeaderOverlays(effectiveLayer);
      const top = this.headerBottom();
      const rect = this.getBoundingClientRect();
      const start = this.navSlot.getBoundingClientRect().top;
      const intro = !this.menu;
      const stuck = !intro && this.dataset.sticky !== 'false' && start < top;
      if (intro) this.navSlot.style.removeProperty('min-height');
      else {
        if (!this.nav.classList.contains('is-stuck')) this.normalHeight = this.nav.getBoundingClientRect().height || this.normalHeight;
        this.navSlot.style.minHeight = this.normalHeight + 'px';
      }
      this.style.setProperty('--psh-top', top + 'px');
      this.style.setProperty('--psh-left', Math.max(0, rect.left) + 'px');
      this.style.setProperty('--psh-span', Math.min(rect.width, window.innerWidth - Math.max(0, rect.left)) + 'px');
      this.nav.classList.toggle('is-stuck', stuck);
      this.syncHeaderJoin(stuck, top);
    }
    bindSections() {
      const owner = this.closest('.shopify-section');
      this.modules.filter(block => block.hasAttribute('data-target')).forEach(block => {
        const raw = block.dataset.target.replace(/^#/, '');
        if (!raw) return;
        const directTarget = document.getElementById(raw);
        const candidates = owner ? Array.from(owner.parentElement.children).filter(element => element.classList.contains('shopify-section') && element.id.endsWith('__' + raw)) : [];
        const target = directTarget || (candidates.length === 1 ? candidates[0] : null);
        const warrantyLink = this.warrantyModule && block.dataset.parent === this.warrantyModule.dataset.parent && block.dataset.categoryKey === 'warranty';
        if (warrantyLink && !target) return;
        const protectedArea = target?.matches('.shopify-section-group-header-group,.shopify-section-group-footer-group') || target?.querySelector('header[role="banner"],footer[role="contentinfo"],panda-service-hub') || this.getHeaders().some(header => target?.contains(header) || header.contains(target));
        if (!owner || !target || !target.classList.contains('shopify-section') || target.parentElement !== owner.parentElement || target === owner || protectedArea || target.contains(this) || target.dataset.pshOwner) { this.warn('无法关联平级 Section: ' + raw); return; }
        this.links.push({ block, target, hidden: target.hidden, suppressed: Boolean(warrantyLink) });
        target.dataset.pshOwner = this.id;
        this.resizeObserver?.observe(target);
      });
      if (!owner || !this.warrantyModule) return;
      Array.from(owner.parentElement.children).forEach(target => {
        const protectedArea = target.matches('.shopify-section-group-header-group,.shopify-section-group-footer-group') || target.querySelector('header[role="banner"],footer[role="contentinfo"],panda-service-hub') || this.getHeaders().some(header => target.contains(header) || header.contains(target));
        if (target === owner || !target.classList.contains('shopify-section') || protectedArea || target.dataset.pshOwner || !target.querySelector('[data-warranty-lookup]')) return;
        this.links.push({ block: this.warrantyModule, target, hidden: target.hidden, suppressed: true });
        target.dataset.pshOwner = this.id;
        this.resizeObserver?.observe(target);
      });
    }
    releaseSections() {
      this.links.forEach(link => { this.resizeObserver?.unobserve(link.target); if (link.target.dataset.pshOwner === this.id) { link.target.hidden = link.hidden; delete link.target.dataset.pshOwner; } });
      this.links = [];
    }
    restoreForm() {
      let pending;
      try { pending = JSON.parse(sessionStorage.getItem('panda-service-contact') || 'null'); } catch {}
      const resultBlocks = this.modules.filter(block => block.querySelector('[data-form-result="true"]'));
      let target = resultBlocks.find(block => block.querySelector('.psh-contact')?.id === location.hash.slice(1));
      if (pending?.section === this.dataset.sectionId && Date.now() - pending.at < 1200000) {
        target ||= resultBlocks.find(block => block.dataset.blockId === pending.block);
        try { sessionStorage.removeItem('panda-service-contact'); } catch {}
      }
      if (target) {
        this.selectContent(target);
        requestAnimationFrame(() => { const y = target.getBoundingClientRect().top + window.scrollY - this.headerBottom() - this.nav.getBoundingClientRect().height - 20; window.scrollTo({ top: Math.max(0, y), behavior: 'instant' }); });
      }
    }
    cleanup() {
      this.stopMenuAnimations();
      this.abort?.abort(); this.abort = null;
      this.resizeObserver?.disconnect();
      this.videoRotationObserver?.disconnect();
      this.headerObserver?.disconnect();
      Array.from(this.raisedHeaders || []).forEach(header => this.releaseHeader(header));
      Array.from(this.joinedHeaders || []).forEach(header => this.releaseHeaderJoin(header));
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.releaseSections();
      this.nav?.classList.remove('is-stuck');
    }
    disconnectedCallback() { this.cleanup(); }
  }
  customElements.define('panda-service-hub', PandaServiceHub);
}
// Original Warranty Lookup frontend; retains /apps/warranty and initialization guard.
(() => {
  const formatDate = (value) => {
    if (!value) return '—';
    const date = new Date(`${value}T00:00:00`);
    if (Number.isNaN(date.getTime())) return value;
    return new Intl.DateTimeFormat(document.documentElement.lang || undefined, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    }).format(date);
  };

  const updateView = (callback) => {
    if (typeof document.startViewTransition === 'function') {
      document.startViewTransition(callback);
    } else {
      callback();
    }
  };

  const initialize = (scope = document) => {
    const roots = scope.matches?.('[data-warranty-lookup]')
      ? [scope]
      : scope.querySelectorAll('[data-warranty-lookup]');

    roots.forEach((root) => {
      if (root.dataset.warrantyInitialized === 'true') return;
      root.dataset.warrantyInitialized = 'true';

      const form = root.querySelector('[data-warranty-form]');
      const button = root.querySelector('[data-submit-button]');
      const message = root.querySelector('[data-message]');
      const result = root.querySelector('[data-result]');
      const initialButtonText = button.textContent.trim();

      const setMessage = (text, tone = 'neutral') => {
        message.textContent = text;
        message.dataset.tone = tone;
        message.hidden = !text;
      };

      const setField = (name, value) => {
        const field = root.querySelector(`[data-field="${name}"]`);
        if (field) field.textContent = value;
      };

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const formData = new FormData(form);
        const serialNumber = String(formData.get('serial_number') || '').trim();
        if (!serialNumber) return;

        button.disabled = true;
        button.textContent = root.dataset.textLoading;
        form.setAttribute('aria-busy', 'true');
        result.hidden = true;
        setMessage(root.dataset.textLoading);

        try {
          const body = new URLSearchParams({ serial_number: serialNumber });
          const response = await fetch(form.action, {
            method: 'POST',
            headers: {
              accept: 'application/json',
              'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
            },
            body: body.toString(),
          });
          const payload = await response.json().catch(() => null);

          if (!response.ok || !payload?.ok) {
            throw new Error('lookup_failed');
          }

          if (!payload.found) {
            updateView(() => {
              result.hidden = true;
              setMessage(root.dataset.textNotFound);
            });
            return;
          }

          const warranty = payload.warranty;
          const years = Number(warranty.warrantyYears);
          const yearUnit = years === 1
            ? root.dataset.textYearSingular
            : root.dataset.textYearPlural;
          const remainingDays = Number(warranty.remainingDays);
          const dayUnit = remainingDays === 1
            ? root.dataset.textDaySingular
            : root.dataset.textDayPlural;

          updateView(() => {
            setMessage('');
            setField('status', warranty.status === 'active'
              ? root.dataset.textActive
              : root.dataset.textExpired);
            const status = root.querySelector('[data-field="status"]');
            if (status) status.dataset.status = warranty.status;
            setField('product', warranty.productName || '—');
            setField('purchase-date', formatDate(warranty.purchaseDate));
            setField('coverage', `${years} ${yearUnit}`);
            setField('expiration-date', formatDate(warranty.expirationDate));
            setField('remaining-days', `${remainingDays} ${dayUnit}`);
            result.hidden = false;
          });
        } catch {
          updateView(() => {
            result.hidden = true;
            setMessage(root.dataset.textError, 'error');
          });
        } finally {
          button.disabled = false;
          button.textContent = initialButtonText;
          form.removeAttribute('aria-busy');
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["proudeer-support-actions"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('proudeer-support-actions')) {
    class ProudeerSupportActions extends HTMLElement {
      connectedCallback() {
        this.handleClick = this.handleClick.bind(this);
        this.handleBackdrop = this.handleBackdrop.bind(this);
        this.handleDialogClose = this.handleDialogClose.bind(this);
        this.dialogs = [...this.querySelectorAll('[data-psa-dialog]')];
        this.addEventListener('click', this.handleClick);
        this.dialogs.forEach((dialog) => {
          dialog.addEventListener('click', this.handleBackdrop);
          dialog.addEventListener('close', this.handleDialogClose);
        });
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.dialogs.forEach((dialog) => {
          dialog.removeEventListener('click', this.handleBackdrop);
          dialog.removeEventListener('close', this.handleDialogClose);
        });
      }

      handleClick(event) {
        const opener = event.target.closest('[data-psa-open], [data-psa-video-open]');
        if (opener && this.contains(opener)) {
          const dialog = document.getElementById(opener.dataset.psaOpen || opener.dataset.psaVideoOpen);
          if (dialog && !dialog.open) {
            const frame = dialog.querySelector('iframe[data-psa-video-src]');
            if (frame) frame.src = frame.dataset.psaVideoSrc;
            dialog.showModal();
          }
          return;
        }
        const closer = event.target.closest('[data-psa-close]');
        if (closer && this.contains(closer)) {
          event.preventDefault();
          this.closeDialog(closer.closest('dialog'));
        }
      }

      handleBackdrop(event) {
        if (event.target === event.currentTarget) this.closeDialog(event.currentTarget);
      }

      handleDialogClose(event) {
        event.currentTarget.querySelectorAll('iframe[data-psa-video-src]').forEach((frame) => frame.removeAttribute('src'));
      }

      closeDialog(dialog) {
        if (!dialog) return;
        dialog.querySelectorAll('dialog[open]').forEach((nestedDialog) => nestedDialog.close());
        dialog.querySelectorAll('iframe[data-psa-video-src]').forEach((frame) => frame.removeAttribute('src'));
        dialog.close();
      }
    }
    customElements.define('proudeer-support-actions', ProudeerSupportActions);
  }

  } catch(e) { console.error(e); }
})();
})();
